export enum Rol {
    ADMIN = 1,
    CLIENTE = 3,
    SHOPPER = 2,
    VENDEDOR = 4,
}
